import React, { Component } from 'react';
import { getProducts } from '../services/productService';
import _ from 'lodash';
import SearchInput from './Common/searchInput';
import ProductBlock from './productBlock';

class SearchPage extends Component {
  state = {
    selectedCategory: 'All',
    searchQuery: '',
    products: [],
    sortBy: { path: 'label', order: 'asc' },
    loading: true,
  };

  async componentDidMount() {
    const { data } = await getProducts();
    this.setState({ products: data , loading: false});
  }

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedCategory: 'All',
      currentPage: 1,
    });
  };

  getSortedData = () => {
    const { products, searchQuery, sortBy } = this.state;

    let filtered = products;
    if (searchQuery)
      filtered = products.filter((p) =>
        p.label.toLowerCase().includes(searchQuery.toLowerCase())
      );
    else filtered = products.filter((p) => p.category === '');

    filtered = _.orderBy(filtered, [sortBy.path], [sortBy.order]);

    return { totalCount: filtered.length, filtered };
  };

  render() {
    const { searchQuery, loading } = this.state;
    const { totalCount, filtered: products } = this.getSortedData();
    let delay = 0;
    const { handleSearchPage } = this.props;

    return (
      <div className='search-page'>
        <div className='search-bar-block'>
          <div className='search-bar'>
            <div className='close-search-page' onClick={handleSearchPage}>
              X
            </div>

            <SearchInput
              value={searchQuery}
              updateSearch={this.handleSearch}
              focus='true'
            />
          </div>
          {totalCount > 0 && <p>Found {totalCount} Products</p>}
        </div>

        <div className='search-page-display'>
         {!loading && <div className='row seatch-products-display'>
            {products.map((p) => (
              <div className='col-4 col-lg-2 col-md-3 col-sm-6'>
                <ProductBlock
                  id={p._id}
                  key={p._id}
                  label={p.label}
                  price={p.price}
                  imageUrl={p.imageUrl}
                  handleLoad={handleSearchPage}
                  animationDelayz={(delay += 0.035)}
                />
              </div>
            ))}
          </div>}
        </div>
      </div>
    );
  }
}

export default SearchPage;
